export default "{\n    \"label\": \"Cliente\",\n    \"placeholder\": \"Seleccione cliente\"\n}\n"